
<section
  class="w-full flex flex-row justify-center FAQ-outer-container bg-themeComponentBg-light font-rubik"
  aria-labelledby="faq-heading"
>
  <div class="w-full max-w-1024 mx-5">
    <div class="w-full flex flex-col lg:flex-row">
      <h2 id="faq-heading" class="w-full mb-5 lg:mb-0 FAQ-h1">
        FAQs
      </h2>

      <div class="w-full space-y-2" role="list">
        <div
          v-for="(faq, index) in faqs"
          :key="index"
          class="rounded-lg shadow-sm bg-themeComponentBg"
          role="listitem"
        >
          <button
            :id="`faq-question-${index}`"
            @click="toggle(index)"
            class="w-full flex justify-between items-center p-4 text-left focus:outline-none"
            :aria-expanded="openIndex === index"
            :aria-controls="`faq-answer-${index}`"
          >
            <span class="FAQ-question-txt">{{ faq.data.question }}</span>
            <img
              src="@/images/FAQ/arrow-drop-down.svg"
              alt=""
              class="h-8 w-8 transition-transform duration-300"
              :class="{ 'transform rotate-180': openIndex === index }"
              aria-hidden="true"
            />
          </button>

          <div
            v-if="openIndex === index"
            :id="`faq-answer-${index}`"
            role="region"
            :aria-labelledby="`faq-question-${index}`"
            class="pl-4 pr-4 pb-4"
          >
            <div class="FAQ-answer" v-html="faq.data.answer.html"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
